export const content = {
  en: {
    brand: 'SmartJob Kenya',
    navJobs: 'Find Jobs',
    navHow: 'How It Works',
    navEmployers: 'For Employers',
    navHelp: 'Help',
    navLogin: 'Log In',
    navSignup: 'Sign Up',
    langTooltip: 'Choose language to translate',
    langEnglish: 'English',
    langSwahili: 'Kiswahili',
    sliderMessages: [
      'Find Jobs Near You Today',
      'Apply Faster. Get Hired Smarter.',
      'Your Next Opportunity Starts Here',
    ],
    heroBadge: 'Kenya-first hiring',
    heroTitle: 'Find Jobs Near You Today',
    heroSubtitle: 'Casual, hourly, part-time, and flexible job opportunities across Kenya.',
    heroButton: 'Search Jobs',
    quickJobSearch: 'Quick job search',
    searchPlaceholder: 'What job are you looking for?',
    locationPlaceholder: 'Select county or location',
    statJobs: 'Active Listings',
    statEmployers: 'Verified Employers',
    statCounties: 'Counties Covered',
    statSeekers: 'Job Seekers',
    howTitle: 'How It Works',
    howSubtitle: 'Get hired in three simple steps.',
    step1Title: 'Create Your Profile',
    step1Desc: 'Sign up free, add your skills, and set your preferred work area.',
    step2Title: 'Search & Apply',
    step2Desc: 'Browse nearby jobs by category, county, or pay type in seconds.',
    step3Title: 'Get Hired Fast',
    step3Desc: 'Connect with verified employers and start earning today.',
    categoriesTitle: 'Popular Job Categories',
    categoriesSubtitle: 'Fast hiring roles for everyday Kenyan workers.',
    nearbyTitle: 'Nearby Jobs',
    nearbySubtitle: 'Local opportunities powered by proximity and mobile-first discovery.',
    viewAllJobs: 'View all nearby jobs',
    featuredTitle: 'Featured Opportunities',
    featuredSubtitle: 'High-demand roles from trusted employers.',
    exploreFeatured: 'Explore featured jobs',
    provenResultsTitle: 'Proven Results on SmartJob',
    provenResultsSubtitle: 'Real hires, faster placements, and trusted outcomes across Kenya.',
    provenResultsStat1: 'Workers placed',
    provenResultsStat2: 'Avg. time to hire',
    provenResultsStat3: 'Employer satisfaction',
    areaPlaceholder: 'Select estate / area',
    employerCounty: 'County',
    employerArea: 'Estate / area',
    employerSelectCounty: 'Select county',
    employerSelectArea: 'Select estate or area',
    loginSeekerRequired: 'Please log in as a job seeker to apply for this role.',
    jobAlertsTitle: 'Get Job Alerts by Email',
    jobAlertsSubtitle: 'Subscribe and we will notify you whenever a new job is posted on SmartJob.',
    jobAlertsPlaceholder: 'Your email address',
    jobAlertsButton: 'Subscribe',
    jobAlertsSuccess: 'You are subscribed! We will email you when new jobs are posted.',
    jobAlertsSuccessTitle: "You're subscribed!",
    jobAlertsSuccessMessage: 'We will email you whenever a new job is posted on SmartJob.',
    jobAlertsAlreadyTitle: 'Already subscribed',
    jobAlertsAlreadyMessage: 'This email is already on our job alert list. You will keep receiving notifications when new jobs are posted.',
    jobAlertsResubscribeTitle: 'Welcome back!',
    jobAlertsResubscribeMessage: 'Your job alerts are active again. We will email you when new jobs are posted.',
    jobAlertsSuccessDone: 'Done',
    jobAlertsInvalid: 'Please enter a valid email address.',
    categoryJobsTitle: 'Jobs in this category',
    categoryJobsEmpty: 'No jobs in this category yet. Check back soon.',
    applyNow: 'Apply now',
    employerTitle: 'Employer Recruitment Tools',
    employerSubtitle: 'Hire fast, post verified listings, and stay visible to nearby talent.',
    employerBullet1: 'Post verified county-based job adverts.',
    employerBullet2: 'Reach workers by location and skill level.',
    employerBullet3: 'Manage candidates and build daily-pay teams.',
    testimonialTitle: 'What Job Seekers Say',
    testimonialSubtitle: 'Trusted by workers across Nairobi, Mombasa, and beyond.',
    contactTitle: 'Contact Us',
    contactSubtitle: 'Have a question? Send us a message.',
    contactEmailLabel: 'Email',
    contactPhoneLabel: 'Phone',
    contactSendTitle: 'Send Message',
    contactSendSubtitle: 'Fill out the form and we will get back to you.',
    contactFormName: 'Name',
    contactFormEmail: 'Email',
    contactFormPhone: 'Phone',
    contactFormMessage: 'Message',
    contactFormNamePlaceholder: 'Your name',
    contactFormEmailPlaceholder: 'Your email address',
    contactFormPhonePlaceholder: 'Your phone number',
    contactFormMessagePlaceholder: 'How can we help you?',
    contactFormSubmit: 'Send Message',
    contactFormSuccess: 'Message sent successfully!',
    contactFormSuccessTitle: 'Message sent!',
    contactFormSuccessMessage: 'Thank you for reaching out. We will get back to you as soon as possible.',
    contactEmailValue: 'tristonmosh@gmail.com',
    contactPhoneValue: '07526985',
    contactFormPhoneOptional: 'Optional',
    contactFormEmailOptional: 'Optional',
    translateTitle: 'Translate English ↔ Kiswahili',
    translateButton: 'Translate',
    switchToEnglish: 'Switch to English',
    switchToSwahili: 'Badilisha Kiswahili',
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Quick answers for job seekers getting started.',
    faq1Q: 'Is SmartJob Kenya free for job seekers?',
    faq1A: 'Yes. Browsing jobs, creating a profile, and applying are completely free.',
    faq2Q: 'What types of jobs can I find?',
    faq2A: 'Casual, hourly, part-time, contract, and daily-pay roles across Kenya.',
    faq3Q: 'How do I find jobs near me?',
    faq3A: 'Use the location filter or enable proximity search to see jobs in your county.',
    faq4Q: 'How do I apply for a job?',
    faq4A: 'Open the job listing, tap Apply, and submit your profile and message to the employer.',
    faq5Q: 'Can I receive SMS alerts for new jobs?',
    faq5A: 'Yes — enable notifications in your profile and we will send SMS alerts for nearby matches.',
    ctaTitle: 'Ready to connect with work near you?',
    ctaButtonJobSeeker: 'Browse Jobs',
    ctaButtonEmployer: 'Post a Job',
    bannerSignupEyebrow: '100% free for job seekers',
    bannerSignupTitle: 'Start finding work near you today',
    bannerSignupMessage: 'Join {count}+ Kenyans already using SmartJob to discover local jobs.',
    bannerSignupCta: 'Create free account',
    footerTagline: 'We connect. You work. Everyone wins.',
    footerSubtagline: 'Together, we work better.',
    footerJobs: 'Browse Jobs',
    footerCategories: 'Categories',
    footerCompanies: 'For Employers',
    footerAbout: 'About Us',
    aboutTitle: 'About SmartJob Kenya',
    aboutSubtitle: 'We connect local talent with real opportunities across Kenya — simply, quickly, and for free.',
    aboutSections: [
      {
        heading: 'Our mission',
        body: 'SmartJob Kenya makes it easy for job seekers to find casual, hourly, and daily-pay work near them, and helps employers reach trusted local talent fast.',
      },
      {
        heading: 'Who we serve',
        body: 'From shop assistants and cleaners to drivers and skilled workers — we support job seekers looking for flexible work and businesses hiring across all 47 counties.',
      },
      {
        heading: 'Our promise',
        body: 'We are building a platform Kenyans can trust: clear job listings, direct applications, and tools that help both sides move from search to hire with confidence.',
      },
    ],
    footerContact: 'Contact',
    footerHelp: 'Help Centre',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
    footerCookies: 'Cookie Policy',
    cookieBannerText: 'We use cookies to keep SmartJob working smoothly for you:',
    cookieBannerAccept: 'Accept cookies',
    legalClose: 'Close',
    legalLastUpdated: 'Last updated: June 2026',
    cookieSections: [
      {
        heading: 'Essential cookies',
        body: 'These keep you signed in, protect your account, and allow core features like browsing jobs and managing applications to work properly.',
      },
      {
        heading: 'Preference cookies',
        body: 'These remember your language, theme, and other settings so SmartJob feels familiar every time you return.',
      },
      {
        heading: 'Analytics cookies',
        body: 'These help us understand how the platform is used so we can improve search, alerts, and the overall experience for job seekers and employers.',
      },
      {
        heading: 'Your choices',
        body: 'By using SmartJob Kenya, you consent to our use of cookies as described here. You can manage browser cookie settings at any time.',
      },
    ],
    privacySections: [
      {
        heading: 'Introduction',
        body: 'SmartJob Kenya respects your privacy. This policy explains what information we collect, how we use it, and the choices you have when using our platform.',
      },
      {
        heading: 'Information we collect',
        body: 'We collect details you provide when signing up or applying for jobs, such as your name, email, phone number, profile photo, and application messages. We also store login sessions and preferences like language and theme.',
      },
      {
        heading: 'How we use your data',
        body: 'Your information is used to create and manage your account, match job seekers with employers, process applications, send job alerts you subscribe to, and improve the SmartJob experience.',
      },
      {
        heading: 'Sharing your information',
        body: 'When you apply for a job, your profile and message are shared with the relevant employer. We do not sell your personal data. We may share limited information with service providers who help us run the platform.',
      },
      {
        heading: 'Your rights',
        body: 'You can update your profile, withdraw applications, and request account changes from your dashboard. Contact us if you need help accessing or correcting your information.',
      },
      {
        heading: 'Contact',
        body: 'For privacy questions, reach SmartJob Kenya through the contact options listed on this site.',
      },
    ],
    termsSections: [
      {
        heading: 'Acceptance of terms',
        body: 'By creating an account or using SmartJob Kenya, you agree to these Terms of Service and our Privacy Policy.',
      },
      {
        heading: 'Accounts',
        body: 'You are responsible for keeping your login details secure and for activity under your account. Provide accurate information when registering as a job seeker or employer.',
      },
      {
        heading: 'Job listings and applications',
        body: 'Employers are responsible for the accuracy of their listings. Job seekers must submit honest applications. SmartJob does not guarantee hiring outcomes or the availability of any role.',
      },
      {
        heading: 'Acceptable use',
        body: 'Do not post misleading jobs, spam, offensive content, or attempt to misuse the platform. We may remove listings or suspend accounts that violate these rules.',
      },
      {
        heading: 'Limitation of liability',
        body: 'SmartJob Kenya is provided as-is. We are not liable for disputes between job seekers and employers, lost opportunities, or indirect damages arising from use of the service.',
      },
      {
        heading: 'Changes',
        body: 'We may update these terms from time to time. Continued use of SmartJob after changes means you accept the updated terms.',
      },
    ],
    footerRights: 'All rights reserved.',
    footerMadeIn: 'Made with pride in Kenya 🇰🇪',
    authBack: 'Back',
    loginTitle: 'Welcome Back',
    loginSubtitle: 'Log in to browse jobs, manage applications, and connect with employers.',
    loginEmail: 'Email address',
    authEmailInvalid: 'Email format is wrong',
    authPlaceholderEmail: 'Enter your email address',
    authPlaceholderPassword: 'Enter your password',
    authPlaceholderName: 'Enter your full name',
    authPlaceholderEmailExample: 'you@example.com',
    loginPassword: 'Password',
    loginButton: 'Log In',
    loginSessionExpired: 'Your session expired due to inactivity. Please log in again.',
    sessionExpiredTitle: 'Session expired',
    sessionExpiredMessage: 'Your session expired due to inactivity. Please log in to continue where you left off.',
    sessionExpiredLogin: 'Log in to continue',
    loginForgot: 'Forgot your password?',
    loginNoAccount: "Don't have an account?",
    loginSignupLink: 'Create one free',
    signupTitle: 'Create Your Account',
    signupSubtitle: 'Join thousands of Kenyans finding work and hiring talent nearby.',
    signupName: 'Full name',
    signupEmail: 'Email address',
    signupPhone: 'Phone number',
    signupPassword: 'Password',
    signupPasswordHint: 'Your password must meet all requirements below.',
    signupPasswordLength: 'At least 8 characters',
    signupPasswordUpper: 'One uppercase letter (A-Z)',
    signupPasswordDigit: 'One number (0-9)',
    signupPasswordSpecial: 'One special character (!@#$...)',
    signupPasswordInvalid: 'Password does not meet all requirements.',
    signupPhoneInvalid: 'Invalid phone number',
    signupButton: 'Create Account',
    signupTermsAgree: 'I agree to the',
    signupTermsRequired: 'You must agree to the Terms and Conditions to create an account.',
    signupHasAccount: 'Already have an account?',
    signupLoginLink: 'Log in',
    signupSuccess: 'Created successfully!',
    loginResetSuccess: 'Password reset successfully! You can now log in.',
    resetTitle: 'Reset Your Password',
    resetSubtitle: 'Enter your email and we will send you a link to reset your password.',
    resetEmail: 'Email address',
    resetButton: 'Send Reset Link',
    resetBackLogin: 'Back to log in',
    resetSuccess: 'Check your inbox! We sent a password reset link to',
    roleTitle: 'How will you use SmartJob?',
    roleSubtitle: 'Choose your path so we can tailor your experience. You can switch later in settings.',
    roleSeekerTitle: "I'm Looking for Work",
    roleSeekerDesc: 'Browse nearby jobs, build your profile, and apply in seconds.',
    roleEmployerTitle: "I'm Hiring Talent",
    roleEmployerDesc: 'Post job listings, reach local workers, and manage applicants.',
    roleContinue: 'Continue',
    roleWelcome: 'Welcome',
    roleChangeLink: 'Change',
    employerDashTitle: 'Employer Dashboard',
    employerDashWelcome: 'Welcome back',
    employerDashSubtitle: 'Post openings and manage your listings.',
    employerPostJob: 'Post a Job',
    employerPostJobDesc: 'Fill in the details below to publish a new listing.',
    employerMyJobs: 'Your Posted Jobs',
    employerMyJobsEmpty: 'No jobs posted yet. Create your first listing.',
    employerJobTitle: 'Job title',
    employerCompany: 'Company / business name',
    employerCategory: 'Category',
    employerLocation: 'County / location',
    employerJobType: 'Job type',
    employerPay: 'Pay',
    employerEmployeesRequired: 'Employees required',
    employerEmployeesRequiredHint: 'How many workers do you need for this role?',
    employerDescription: 'Job description',
    employerPostButton: 'Publish Job',
    employerEditJob: 'Edit Job',
    employerEditJobDesc: 'Update the details for this listing.',
    employerSaveChanges: 'Save Changes',
    employerCancelEdit: 'Cancel',
    employerCloseJob: 'Close Job',
    employerJobClosed: 'Closed',
    employerJobActive: 'Active',
    employerUpdateSuccess: 'Job updated successfully!',
    employerCloseSuccess: 'Job closed successfully.',
    employerPostSuccess: 'Job posted successfully!',
    employerDeleteJob: 'Remove',
    employerDeleteConfirmTitle: 'Remove this job?',
    employerDeleteConfirmMessage: 'This listing will be permanently deleted along with all applications. This cannot be undone.',
    employerDeleteConfirmBtn: 'Yes, remove',
    employerDeleteCancel: 'Cancel',
    employerLogout: 'Log Out',
    employerLogoutSuccess: 'Logged out successfully.',
    employerBackHome: 'Back Home',
    employerPostedOn: 'Posted',
    employerSelectCategory: 'Select category',
    employerSelectLocation: 'Select county',
    employerSelectJobType: 'Select job type',
    employerProfile: 'Profile',
    employerMyProfile: 'My Profile',
    employerSettings: 'Settings',
    employerSettingsTitle: 'Account Settings',
    employerSettingsSubtitle: 'Customize your SmartJob experience.',
    employerProfileTitle: 'My Profile',
    employerProfileSubtitle: 'Manage your account, appearance, and security settings.',
    employerProfilePhoto: 'Profile Photo',
    employerUploadPhoto: 'Upload Photo',
    employerRemovePhoto: 'Remove Photo',
    employerPhotoSuccess: 'Profile photo updated.',
    employerPhotoRemoved: 'Profile photo removed.',
    employerPhotoInvalid: 'Please choose a valid image file.',
    employerPhotoTooLarge: 'Image must be under 2 MB.',
    employerMyDetails: 'My Details',
    employerMyDetailsDesc: 'Your account information from signup.',
    employerTheme: 'Appearance',
    employerThemeDesc: 'Choose how SmartJob looks on your device.',
    employerThemeLight: 'Light',
    employerThemeDark: 'Dark',
    chatTitle: 'SmartJob Assistant',
    chatSubtitle: 'Ask me anything about jobs & applications',
    chatWelcomeGuest: 'Welcome to SmartJob Kenya! How may I help you today?',
    chatWelcomeSeeker: 'Welcome, {name}! How may I help you today?',
    chatWelcomeEmployer: 'Welcome, {name}! How may I help you today?',
    chatPlaceholder: 'Type your message...',
    chatSend: 'Send',
    chatOpen: 'Open chat assistant',
    chatClose: 'Close chat',
    chatTyping: 'Assistant is typing',
    chatError: 'Something went wrong. Please try again.',
    chatSuggestionsGuest: ['Find jobs in Nairobi', 'How do I sign up?', 'Is it free for job seekers?'],
    chatSuggestionsSeeker: ['Where is my application?', 'How do I apply for a job?', 'How many words for an application?'],
    chatSuggestionsEmployer: ['Show my jobs', 'How do I review applicants?', 'How do I post a job?'],
    themeSwitchToLight: 'Switch to light mode',
    themeSwitchToDark: 'Switch to dark mode',
    employerChangePassword: 'Change Password',
    employerChangePasswordDesc: 'Update your password to keep your account secure.',
    employerCurrentPassword: 'Current password',
    employerNewPassword: 'New password',
    employerConfirmPassword: 'Confirm new password',
    employerUpdatePassword: 'Update Password',
    employerModalCancel: 'Cancel',
    employerPasswordSuccess: 'Password updated successfully.',
    employerPasswordSuccessCheck: 'Your password has been updated successfully. Use your new password next time you sign in.',
    employerPasswordWrong: 'Current password is incorrect.',
    employerPasswordMismatch: 'New passwords do not match.',
    employerBackDashboard: 'Back to dashboard',
    employerBackNav: 'Back',
    employerNotifications: 'Notifications',
    employerNotificationsTitle: 'Your Notifications',
    employerNotificationsSubtitle: 'Stay updated on your listings and account activity.',
    employerNotificationsEmpty: 'No notifications yet. We will alert you when something happens.',
    employerMarkRead: 'Mark as read',
    employerMarkAllRead: 'Mark all read',
    employerArchive: 'Archive',
    employerNotifJobPosted: 'Job posted successfully',
    notifWelcomeEmployerTitle: 'Welcome to SmartJob Kenya',
    notifWelcomeEmployerMessage: 'Hi {name}, your employer account is ready. Post your first job to reach local talent.',
    notifWelcomeSeekerTitle: 'Welcome to SmartJob Kenya',
    notifWelcomeSeekerMessage: 'Hi {name}, your job seeker account is ready. Browse nearby jobs and start applying today.',
    seekerDashTitle: 'Job Seeker Dashboard',
    seekerDashWelcome: 'Welcome back',
    seekerDashSubtitle: 'Browse jobs, track applications, and manage your profile.',
    seekerProfileSubtitle: 'Manage your photo and contact details so employers can reach you.',
    seekerBrowseDesc: 'Search casual, hourly, and daily-pay roles near you.',
    seekerTabBrowseJobs: 'Browse Jobs',
    seekerTabSavedJobs: 'Saved Jobs',
    seekerSavedJobsDesc: 'Jobs you saved to apply later.',
    seekerNoSavedJobs: 'No saved jobs yet. Save jobs from Browse Jobs to apply later.',
    seekerProfileCardDesc: 'Keep your profile up to date for faster applications.',
    seekerApplications: 'Applications',
    seekerApplicationsDesc: 'Track jobs you have applied to and their status.',
    seekerTabApplications: 'My Applications',
    seekerNoApplications: 'No applications yet. Browse jobs and apply to get started.',
    seekerApplyNow: 'Apply now',
    seekerApplying: 'Submitting...',
    seekerApplied: 'Applied',
    seekerApplyTitle: 'Apply for this job',
    seekerApplyDesc: 'Your profile will be shared with the employer along with your message.',
    seekerApplyMessage: 'Your message to the employer',
    seekerApplyMessagePlaceholder: 'Introduce yourself, mention your experience, and why you are a good fit...',
    seekerApplyMessageHint: 'Write at least 15 words. Be clear and professional.',
    seekerApplyMessageTooShort: 'Your message needs at least 15 words before you can submit.',
    seekerApplyWordCount: '{count} / 15 words',
    seekerApplySubmit: 'Submit application',
    seekerApplySuccessTitle: 'Application submitted',
    seekerApplySuccessMessage: 'Your profile and message have been sent to the employer. You can track the status under My Applications.',
    seekerApplySuccessDone: 'Done',
    seekerWithdrawApplication: 'Withdraw application',
    seekerWithdrawTitle: 'Withdraw application?',
    seekerWithdrawConfirm: 'Are you sure you want to withdraw? The employer will no longer see your application for this job.',
    seekerWithdrawConfirmBtn: 'Yes, withdraw',
    seekerWithdrawCancel: 'Keep application',
    seekerWithdrawing: 'Withdrawing...',
    seekerWithdrawSuccess: 'Application withdrawn. You can apply again if you change your mind.',
    seekerYourProfile: 'Your profile',
    seekerApplicationMessage: 'Your message',
    seekerAppliedOn: 'Applied on',
    applicationStatusPending: 'Pending',
    applicationStatusViewed: 'Viewed',
    applicationStatusContacted: 'Contacted',
    employerViewApplicants: 'View applicants',
    employerApplicants: 'Applicants',
    employerApplicantsDesc: 'People who applied to this job listing.',
    employerNoApplicants: 'No applications yet. Share your listing to attract candidates.',
    employerApplicantProfile: 'View profile',
    employerApplicantMessage: 'Application message',
    employerUpdateStatus: 'Update status',
    employerApplicantContact: 'Contact details',
    employerApplicantApplied: 'Applied',
    employerApplicationCount: 'applications',
    employerMarkContacted: 'Mark as contacted',
    employerMarkViewed: 'Mark as viewed',
    employerSeekerProfile: 'Applicant profile',
    employerSeekerProfileDesc: 'Profile details shared with your application.',
    employerSeekerPhone: 'Phone',
    employerSeekerEmail: 'Email',
    employerCloseApplicants: 'Close',
    seekerNoJobs: 'No jobs posted yet. Check back soon.',
    seekerSearchNoResults: 'No jobs match your search. Try different keywords or location.',
    seekerRefreshJobs: 'Refresh',
    seekerJobsRefreshed: 'Job list refreshed. Showing all available jobs.',
    seekerSearchFiltered: 'Showing filtered results.',
    seekerClearSearch: 'Refresh all jobs',
    seekerPostedBy: 'Posted by',
    seekerPostedOn: 'Posted on',
    seekerLikeJob: 'Like this job',
    seekerDislikeJob: 'Dislike this job',
    seekerJobDetails: 'Job details',
    seekerBackToJobs: 'Back to jobs',
    seekerSaveForLater: 'Save to apply later',
    seekerSavedForLater: 'Saved for later',
    seekerJobNotFound: 'Job not found or no longer available.',
    seekerJobDescription: 'Description',
    seekerEmployeesRequired: 'Employees required',
    seekerJobSaved: 'Job saved for later',
    seekerJobUnsaved: 'Removed from saved jobs',
    seekerRemoveFromSaved: 'Remove from saved',
    shareJob: 'Share job',
    shareJobCopied: 'Job link copied! Send it to a friend.',
    shareJobShared: 'Job shared successfully.',
    shareJobFailed: 'Could not share this job. Please try again.',
    landingNoJobs: 'No active listings yet. Be the first employer to post a job.',
  },
  sw: {
    brand: 'SmartJob Kenya',
    navJobs: 'Tafuta Kazi',
    navHow: 'Jinsi Inavyofanya',
    navEmployers: 'Kwa Waajiri',
    navHelp: 'Msaada',
    navLogin: 'Ingia',
    navSignup: 'Jisajili',
    langTooltip: 'Chagua lugha ya kutafsiri',
    langEnglish: 'English',
    langSwahili: 'Kiswahili',
    sliderMessages: [
      'Pata Kazi Karibu Nao Leo',
      'Omba Haraka. Pata Kazi kwa Akili.',
      'Fursa Yako Inayofuata Inaanza Hapa',
    ],
    heroBadge: 'Kuajiri kwanza Kenya',
    heroTitle: 'Pata Kazi Karibu Nawe Leo',
    heroSubtitle: 'Kazi za kila siku, kwa saa, sehemu ya muda, na fursa rahisi za kazi kote Kenya.',
    heroButton: 'Tafuta Kazi',
    quickJobSearch: 'Tafuta kazi haraka',
    searchPlaceholder: 'Unatafuta kazi gani?',
    locationPlaceholder: 'Chagua kaunti au eneo',
    statJobs: 'Matangazo Yanayoendelea',
    statEmployers: 'Waajiri Waliothibitishwa',
    statCounties: 'Kaunti Zilizofunikwa',
    statSeekers: 'Watafuta Kazi',
    howTitle: 'Jinsi Inavyofanya',
    howSubtitle: 'Pata kazi kwa hatua tatu rahisi.',
    step1Title: 'Unda Wasifu Wako',
    step1Desc: 'Jisajili bure, ongeza ujuzi wako, na weka eneo lako la kupendelea.',
    step2Title: 'Tafuta & Omba',
    step2Desc: 'Vinjari kazi za karibu kwa kategoria, kaunti, au aina ya malipo kwa sekunde.',
    step3Title: 'Pata Kazi Haraka',
    step3Desc: 'Ungana na waajiri waliothibitishwa na uanze kupata mapato leo.',
    categoriesTitle: 'Aina za Kazi Maarufu',
    categoriesSubtitle: 'Kazi za kuajiriwa kwa haraka kwa wafanyakazi wa kila siku.',
    nearbyTitle: 'Kazi Karibu Yako',
    nearbySubtitle: 'Fursa za karibu kwa kusaidiwa na eneo na simu.',
    viewAllJobs: 'Angalia kazi zote za karibu',
    featuredTitle: 'Fursa Zilizochaguliwa',
    featuredSubtitle: 'Majukumu yanayohitajiwa sana kutoka kwa waajiri wa kuaminiwa.',
    exploreFeatured: 'Chunguza kazi zilizochaguliwa',
    provenResultsTitle: 'Matokeo Yaliyothibitishwa kwenye SmartJob',
    provenResultsSubtitle: 'Kuajiriwa halisi, nafasi za haraka, na matokeo ya kuaminiwa nchini Kenya.',
    provenResultsStat1: 'Wafanyakazi waliopangiwa',
    provenResultsStat2: 'Muda wa wastani wa kuajiri',
    provenResultsStat3: 'Kuridhika kwa waajiri',
    areaPlaceholder: 'Chagua eneo / mtaa',
    employerCounty: 'Kaunti',
    employerArea: 'Eneo / mtaa',
    employerSelectCounty: 'Chagua kaunti',
    employerSelectArea: 'Chagua eneo au mtaa',
    loginSeekerRequired: 'Tafadhali ingia kama mtafuta kazi ili kuomba kazi hii.',
    jobAlertsTitle: 'Pata Arifa za Kazi kwa Barua Pepe',
    jobAlertsSubtitle: 'Jiandikishe na tutakujulisha kila kazi mpya inapochapishwa kwenye SmartJob.',
    jobAlertsPlaceholder: 'Anwani yako ya barua pepe',
    jobAlertsButton: 'Jiandikishe',
    jobAlertsSuccess: 'Umejiandikisha! Tutakutumia barua pepe kazi mpya zinapochapishwa.',
    jobAlertsSuccessTitle: 'Umejiandikisha!',
    jobAlertsSuccessMessage: 'Tutakutumia barua pepe kila kazi mpya inapochapishwa kwenye SmartJob.',
    jobAlertsAlreadyTitle: 'Tayari umejiandikisha',
    jobAlertsAlreadyMessage: 'Barua pepe hii tayari iko kwenye orodha yetu ya arifa. Utaendelea kupokea arifa kazi mpya zinapochapishwa.',
    jobAlertsResubscribeTitle: 'Karibu tena!',
    jobAlertsResubscribeMessage: 'Arifa zako za kazi zimewashwa tena. Tutakutumia barua pepe kazi mpya zinapochapishwa.',
    jobAlertsSuccessDone: 'Maliza',
    jobAlertsInvalid: 'Tafadhali weka anwani sahihi ya barua pepe.',
    categoryJobsTitle: 'Kazi katika kategoria hii',
    categoryJobsEmpty: 'Hakuna kazi katika kategoria hii bado. Rudi hivi karibuni.',
    applyNow: 'Omba sasa',
    employerTitle: 'Zana za Kuajiri Waajiri',
    employerSubtitle: 'Ajiri haraka, tuma matangazo yaliyothibitishwa, na uwe wazi kwa vipaji vya karibu.',
    employerBullet1: 'Tuma matangazo ya kazi yaliyothibitishwa kwa kaunti.',
    employerBullet2: 'Fikia wafanyakazi kwa eneo na kiwango cha ujuzi.',
    employerBullet3: 'Simamia wagombea na jenga timu za malipo ya kila siku.',
    testimonialTitle: 'Watafuta Kazi Wanasema',
    testimonialSubtitle: 'Imethibitishwa na wafanyakazi Nairobi, Mombasa, na kwingineko.',
contactTitle: 'Wasiliana Nasi',
    contactSubtitle: 'Una swali? Tumia ujumbe.',
    contactEmailLabel: 'Barua Pepe',
    contactPhoneLabel: 'Simu',
    contactSendTitle: 'Tuma Ujumbe',
    contactSendSubtitle: 'Jaza fomu na tutakurudia.',
    contactFormName: 'Jina',
    contactFormEmail: 'Barua Pepe',
    contactFormPhone: 'Simu',
    contactFormMessage: 'Ujumbe',
    contactFormNamePlaceholder: 'Jina lako',
    contactFormEmailPlaceholder: 'Anwani yako ya barua pepe',
    contactFormPhonePlaceholder: 'Nambari yako ya simu',
    contactFormMessagePlaceholder: 'Tunaweza kukusaidia vipi?',
    contactFormSubmit: 'Tuma Ujumbe',
    contactFormSuccess: 'Ujumbe umetumwa kwa mafanikio!',
    contactFormSuccessTitle: 'Ujumbe umetumwa!',
    contactFormSuccessMessage: 'Asante kwa kuwasiliana nasi. Tutakujibu haraka iwezekanavyo.',
    contactEmailValue: 'tristonmosh@gmail.com',
    contactPhoneValue: '07526985',
    contactFormPhoneOptional: 'Hiari',
    contactFormEmailOptional: 'Hiari',
    translateTitle: 'Tafsiri Kiingereza ↔ Kiswahili',
    translateButton: 'Tafsiri',
    switchToSwahili: 'Badilisha Kiswahili',
    faqTitle: 'Maswali Yanayoulizwa Mara kwa Mara',
    faqSubtitle: 'Majibu ya haraka kwa watafuta kazi wanaanza.',
    faq1Q: 'Je, SmartJob Kenya ni bure kwa watafuta kazi?',
    faq1A: 'Ndiyo. Kutafuta kazi, kuunda wasifu, na kuomba ni bure kabisa.',
    faq2Q: 'Ni aina gani za kazi ninaweza kupata?',
    faq2A: 'Kazi za kila siku, kwa saa, sehemu ya muda, kandarasi, na malipo ya kila siku nchini Kenya.',
    faq3Q: 'Ninawezaje kupata kazi karibu nami?',
    faq3A: 'Tumia kichujio cha eneo au wezesha utafutaji wa karibu kuona kazi katika kaunti yako.',
    ctaTitle: 'Uko tayari kuungana na kazi karibu yako?',
    ctaButtonJobSeeker: 'Vinjari Kazi',
    ctaButtonEmployer: 'Tuma Kazi',
    bannerSignupEyebrow: 'Bure 100% kwa watafuta kazi',
    bannerSignupTitle: 'Anza kupata kazi karibu yako leo',
    bannerSignupMessage: 'Jiunge na Wakenya {count}+ tayari wanatumia SmartJob kupata kazi za ndani.',
    bannerSignupCta: 'Unda akaunti bure',
    footerTagline: 'Tunaunganisha. Unafanya kazi. Kila mtu anashinda.',
    footerSubtagline: 'Pamoja, tunafanya kazi vizuri zaidi.',
    footerJobs: 'Vinjari Kazi',
    footerCategories: 'Kategoria',
    footerCompanies: 'Kwa Waajiri',
    footerAbout: 'Kuhusu Sisi',
    aboutTitle: 'Kuhusu SmartJob Kenya',
    aboutSubtitle: 'Tunaunganisha talanta ya ndani na fursa halisi kote Kenya — kwa urahisi, haraka, na bure.',
    aboutSections: [
      {
        heading: 'Dhamira yetu',
        body: 'SmartJob Kenya inawafanya watafuta kazi kupata kazi za muda, saa, na malipo ya kila siku karibu nao, na kuwasaidia waajiri kufikia vipaji vya kuaminika haraka.',
      },
      {
        heading: 'Tunaowahudumia',
        body: 'Kuanzia wasaidizi wa maduka na wasafishaji hadi madereva na wafanyakazi wenye ujuzi — tunasaidia watafuta kazi wanaotafuta kazi rahisi na biashara zinazoaajiri katika kaunti zote 47.',
      },
      {
        heading: 'Ahadi yetu',
        body: 'Tunajenga jukwaa Wakenya wanaweza kuamini: matangazo ya kazi wazi, maombi ya moja kwa moja, na zana zinazosaidia pande zote mbili kutoka utafutaji hadi kuajiriwa kwa ujasiri.',
      },
    ],
    footerContact: 'Wasiliana',
    footerHelp: 'Kituo cha Msaada',
    footerPrivacy: 'Sera ya Faragha',
    footerTerms: 'Masharti ya Huduma',
    footerCookies: 'Sera ya Vidakuzi',
    cookieBannerText: 'Tunatumia vidakuzi ili SmartJob ifanye kazi vizuri kwako:',
    cookieBannerAccept: 'Kubali vidakuzi',
    legalClose: 'Funga',
    legalLastUpdated: 'Ilisasishwa mwisho: Juni 2026',
    cookieSections: [
      {
        heading: 'Vidakuzi muhimu',
        body: 'Hivi vinakusaidia kubaki umeingia, kulinda akaunti yako, na kuruhusu vipengele muhimu kama kutafuta kazi na kusimamia maombi kufanya kazi vizuri.',
      },
      {
        heading: 'Vidakuzi vya mapendeleo',
        body: 'Hivi vinakumbuka lugha yako, mandhari, na mipangilio mingine ili SmartJob iwe rahisi kila unaporudi.',
      },
      {
        heading: 'Vidakuzi vya uchambuzi',
        body: 'Hivi vinatusaidia kuelewa jinsi jukwaa linavyotumika ili tuboreshe utafutaji, arifa, na uzoefu kwa watafuta kazi na waajiri.',
      },
      {
        heading: 'Chaguo zako',
        body: 'Kwa kutumia SmartJob Kenya, unakubali matumizi yetu ya vidakuzi kama ilivyoelezwa hapa. Unaweza kudhibiti mipangilio ya vidakuzi kwenye kivinjari chako wakati wowote.',
      },
    ],
    privacySections: [
      {
        heading: 'Utangulizi',
        body: 'SmartJob Kenya inaheshimu faragha yako. Sera hii inaeleza taarifa tunazokusanya, jinsi tunazitumia, na chaguo ulizonazo unapotumia jukwaa letu.',
      },
      {
        heading: 'Taarifa tunazokusanya',
        body: 'Tunakusanya maelezo unayotoa unapojiandikisha au kuomba kazi, kama jina, barua pepe, nambari ya simu, picha ya wasifu, na ujumbe wa maombi. Pia tunahifadhi vikao vya kuingia na mapendeleo kama lugha na mandhari.',
      },
      {
        heading: 'Jinsi tunavyotumia data yako',
        body: 'Taarifa zako zinatumika kuunda na kusimamia akaunti yako, kuunganisha watafuta kazi na waajiri, kuchakata maombi, kutuma arifa za kazi ulizojiandikisha, na kuboresha uzoefu wa SmartJob.',
      },
      {
        heading: 'Kushiriki taarifa zako',
        body: 'Unapoomba kazi, wasifu wako na ujumbe wako vinashirikiwa na mwajiri husika. Hatuuzi data yako ya kibinafsi. Tunaweza kushiriki taarifa chache na watoa huduma wanaotusaidia kuendesha jukwaa.',
      },
      {
        heading: 'Haki zako',
        body: 'Unaweza kusasisha wasifu wako, kuondoa maombi, na kuomba mabadiliko ya akaunti kutoka dashibodi yako. Wasiliana nasi ikiwa unahitaji msaada kufikia au kusahihisha taarifa zako.',
      },
      {
        heading: 'Wasiliana',
        body: 'Kwa maswali ya faragha, wasiliana na SmartJob Kenya kupitia chaguo za mawasiliano zilizoorodheshwa kwenye tovuti hii.',
      },
    ],
    termsSections: [
      {
        heading: 'Kukubali masharti',
        body: 'Kwa kuunda akaunti au kutumia SmartJob Kenya, unakubali Masharti haya ya Huduma na Sera yetu ya Faragha.',
      },
      {
        heading: 'Akaunti',
        body: 'Unawajibika kulinda maelezo yako ya kuingia na shughuli chini ya akaunti yako. Toa taarifa sahihi unapojiandikisha kama mtafuta kazi au mwajiri.',
      },
      {
        heading: 'Matangazo na maombi ya kazi',
        body: 'Waajiri wanawajibika kwa usahihi wa matangazo yao. Watafuta kazi lazima watoe maombi ya kweli. SmartJob haihakikishi kuajiriwa au upatikanaji wa kazi yoyote.',
      },
      {
        heading: 'Matumizi yanayokubalika',
        body: 'Usichapishe kazi za uongo, barua taka, maudhui ya kukera, au kujaribu kutumia vibaya jukwaa. Tunaweza kuondoa matangazo au kusimamisha akaunti zinazokiuka sheria hizi.',
      },
      {
        heading: 'Ukomo wa uwajibikaji',
        body: 'SmartJob Kenya inatolewa kama ilivyo. Hatuwajibiki kwa migogoro kati ya watafuta kazi na waajiri, fursa zilizopotea, au uharibifu wa moja kwa moja unaotokana na matumizi ya huduma.',
      },
      {
        heading: 'Mabadiliko',
        body: 'Tunaweza kusasisha masharti haya mara kwa mara. Kuendelea kutumia SmartJob baada ya mabadiliko kunamaanisha unakubali masharti yaliyosasishwa.',
      },
    ],
    footerRights: 'Haki zote zimehifadhiwa.',
    footerMadeIn: 'Imetengenezwa kwa kiburi nchini Kenya 🇰🇪',
    authBack: 'Rudi',
    loginTitle: 'Karibu Tena',
    loginSubtitle: 'Ingia ili kutafuta kazi, kusimamia maombi, na kuungana na waajiri.',
    loginEmail: 'Anwani ya barua pepe',
    authEmailInvalid: 'Muundo wa barua pepe si sahihi',
    authPlaceholderEmail: 'Weka anwani yako ya barua pepe',
    authPlaceholderPassword: 'Weka nenosiri lako',
    authPlaceholderName: 'Weka jina lako kamili',
    authPlaceholderEmailExample: 'wewe@mfano.com',
    loginPassword: 'Nenosiri',
    loginButton: 'Ingia',
    loginSessionExpired: 'Kikao chako kimeisha kwa kutokuwa na shughuli. Tafadhali ingia tena.',
    sessionExpiredTitle: 'Kikao kimeisha',
    sessionExpiredMessage: 'Kikao chako kimeisha kwa kutokuwa na shughuli. Tafadhali ingia ili kuendelea ulipoishia.',
    sessionExpiredLogin: 'Ingia ili kuendelea',
    loginForgot: 'Umesahau nenosiri?',
    loginNoAccount: 'Huna akaunti?',
    loginSignupLink: 'Unda bure',
    signupTitle: 'Unda Akaunti Yako',
    signupSubtitle: 'Jiunge na maelfu ya Wakenya wanaopata kazi na kuajiri vipaji karibu.',
    signupName: 'Jina kamili',
    signupEmail: 'Anwani ya barua pepe',
    signupPhone: 'Nambari ya simu',
    signupPassword: 'Nenosiri',
    signupPasswordHint: 'Nenosiri lako lazima litimize mahitaji yote hapa chini.',
    signupPasswordLength: 'Angalau herufi 8',
    signupPasswordUpper: 'Herufi kubwa moja (A-Z)',
    signupPasswordDigit: 'Nambari moja (0-9)',
    signupPasswordSpecial: 'Alama maalum moja (!@#$...)',
    signupPasswordInvalid: 'Nenosiri halitimizi mahitaji yote.',
    signupPhoneInvalid: 'Nambari ya simu si sahihi',
    signupButton: 'Unda Akaunti',
    signupTermsAgree: 'Ninakubali',
    signupTermsRequired: 'Lazima ukubali Masharti ya Huduma ili kuunda akaunti.',
    signupHasAccount: 'Tayari una akaunti?',
    signupLoginLink: 'Ingia',
    signupSuccess: 'Imeundwa kikamilifu!',
    loginResetSuccess: 'Nenosiri limewekwa upya kwa mafanikio! Sasa unaweza kuingia.',
    resetTitle: 'Weka Upya Nenosiri',
    resetSubtitle: 'Weka barua pepe yako na tutakutumia kiungo cha kuweka upya nenosiri.',
    resetEmail: 'Anwani ya barua pepe',
    resetButton: 'Tuma Kiungo cha Kuweka Upya',
    resetBackLogin: 'Rudi kuingia',
    resetSuccess: 'Angalia barua pepe yako! Tumetuma kiungo cha kuweka upya nenosiri kwa',
    roleTitle: 'Utatumia SmartJob vipi?',
    roleSubtitle: 'Chagua njia yako ili tuweze kukufanyia uzoefu unaofaa. Unaweza kubadilisha baadaye.',
    roleSeekerTitle: 'Natafuta Kazi',
    roleSeekerDesc: 'Vinjari kazi za karibu, jenga wasifu wako, na omba kwa sekunde.',
    roleEmployerTitle: 'Ninaajiri Wafanyakazi',
    roleEmployerDesc: 'Tuma matangazo ya kazi, fikia wafanyakazi wa karibu, na simamia waombaji.',
    roleContinue: 'Endelea',
    roleWelcome: 'Karibu',
    roleChangeLink: 'Badilisha',
    employerDashTitle: 'Dashibodi ya Mwajiri',
    employerDashWelcome: 'Karibu tena',
    employerDashSubtitle: 'Tuma matangazo na simamia orodha zako.',
    employerPostJob: 'Tuma Kazi',
    employerPostJobDesc: 'Jaza maelezo hapa chini kuchapisha tangazo jipya.',
    employerMyJobs: 'Kazi Ulizotuma',
    employerMyJobsEmpty: 'Hakuna kazi bado. Unda tangazo lako la kwanza.',
    employerJobTitle: 'Kichwa cha kazi',
    employerCompany: 'Jina la kampuni / biashara',
    employerCategory: 'Kategoria',
    employerLocation: 'Kaunti / eneo',
    employerJobType: 'Aina ya kazi',
    employerPay: 'Malipo',
    employerEmployeesRequired: 'Wafanyakazi wanahitajika',
    employerEmployeesRequiredHint: 'Unahitaji wafanyakazi wangapi kwa kazi hii?',
    employerDescription: 'Maelezo ya kazi',
    employerPostButton: 'Chapisha Kazi',
    employerEditJob: 'Hariri Kazi',
    employerEditJobDesc: 'Sasisha maelezo ya tangazo hili.',
    employerSaveChanges: 'Hifadhi Mabadiliko',
    employerCancelEdit: 'Ghairi',
    employerCloseJob: 'Funga Kazi',
    employerJobClosed: 'Imefungwa',
    employerJobActive: 'Inaendelea',
    employerUpdateSuccess: 'Kazi imesasishwa kwa mafanikio!',
    employerCloseSuccess: 'Kazi imefungwa kwa mafanikio.',
    employerPostSuccess: 'Kazi imechapishwa kwa mafanikio!',
    employerDeleteJob: 'Ondoa',
    employerDeleteConfirmTitle: 'Ondoa kazi hii?',
    employerDeleteConfirmMessage: 'Tangazo hili litafutwa kabisa pamoja na maombi yote. Hili haliwezi kutenduliwa.',
    employerDeleteConfirmBtn: 'Ndiyo, ondoa',
    employerDeleteCancel: 'Ghairi',
    employerLogout: 'Toka',
    employerLogoutSuccess: 'Umetoka kwa mafanikio.',
    employerBackHome: 'Rudi Nyumbani',
    employerPostedOn: 'Imechapishwa',
    employerSelectCategory: 'Chagua kategoria',
    employerSelectLocation: 'Chagua kaunti',
    employerSelectJobType: 'Chagua aina ya kazi',
    employerProfile: 'Wasifu',
    employerMyProfile: 'Wasifu Wangu',
    employerSettings: 'Mipangilio',
    employerSettingsTitle: 'Mipangilio ya Akaunti',
    employerSettingsSubtitle: 'Badilisha uzoefu wako wa SmartJob.',
    employerProfileTitle: 'Wasifu Wangu',
    employerProfileSubtitle: 'Simamia akaunti yako, muonekano, na mipangilio ya usalama.',
    employerProfilePhoto: 'Picha ya Wasifu',
    employerUploadPhoto: 'Pakia Picha',
    employerRemovePhoto: 'Ondoa Picha',
    employerPhotoSuccess: 'Picha ya wasifu imesasishwa.',
    employerPhotoRemoved: 'Picha ya wasifu imeondolewa.',
    employerPhotoInvalid: 'Tafadhali chagua faili halali ya picha.',
    employerPhotoTooLarge: 'Picha lazima iwe chini ya MB 2.',
    employerMyDetails: 'Maelezo Yangu',
    employerMyDetailsDesc: 'Taarifa za akaunti yako kutoka usajili.',
    employerTheme: 'Muonekano',
    employerThemeDesc: 'Chagua jinsi SmartJob inavyoonekana kwenye kifaa chako.',
    employerThemeLight: 'Mwanga',
    employerThemeDark: 'Giza',
    chatTitle: 'Msaidizi wa SmartJob',
    chatSubtitle: 'Niulize chochote kuhusu kazi na maombi',
    chatWelcomeGuest: 'Karibu SmartJob Kenya! Naweza kukusaidia vipi leo?',
    chatWelcomeSeeker: 'Karibu, {name}! Naweza kukusaidia vipi leo?',
    chatWelcomeEmployer: 'Karibu, {name}! Naweza kukusaidia vipi leo?',
    chatPlaceholder: 'Andika ujumbe wako...',
    chatSend: 'Tuma',
    chatOpen: 'Fungua msaidizi wa mazungumzo',
    chatClose: 'Funga mazungumzo',
    chatTyping: 'Msaidizi anaandika',
    chatError: 'Kuna tatizo. Tafadhali jaribu tena.',
    chatSuggestionsGuest: ['Tafuta kazi Nairobi', 'Ninawezaje kujisajili?', 'Je, ni bure kwa watafuta kazi?'],
    chatSuggestionsSeeker: ['Maombi yangu yako wapi?', 'Ninawezaje kuomba kazi?', 'Ninahitaji maneno mangapi kuomba?'],
    chatSuggestionsEmployer: ['Onyesha kazi zangu', 'Ninawezaje kuangalia waombaji?', 'Ninawezaje kuchapisha kazi?'],
    themeSwitchToLight: 'Badilisha hali ya mwanga',
    themeSwitchToDark: 'Badilisha hali ya giza',
    employerChangePassword: 'Badilisha Nenosiri',
    employerChangePasswordDesc: 'Sasisha nenosiri lako ili kulinda akaunti yako.',
    employerCurrentPassword: 'Nenosiri la sasa',
    employerNewPassword: 'Nenosiri jipya',
    employerConfirmPassword: 'Thibitisha nenosiri jipya',
    employerUpdatePassword: 'Sasisha Nenosiri',
    employerModalCancel: 'Ghairi',
    employerPasswordSuccess: 'Nenosiri limesasishwa kwa mafanikio.',
    employerPasswordSuccessCheck: 'Nenosiri lako limesasishwa kwa mafanikio. Tumia nenosiri jipya unapoingia tena.',
    employerPasswordWrong: 'Nenosiri la sasa si sahihi.',
    employerPasswordMismatch: 'Nenosiri jipya halilingani.',
    employerBackDashboard: 'Rudi kwenye dashibodi',
    employerBackNav: 'Rudi',
    employerNotifications: 'Arifa',
    employerNotificationsTitle: 'Arifa Zako',
    employerNotificationsSubtitle: 'Pata taarifa kuhusu matangazo na shughuli za akaunti yako.',
    employerNotificationsEmpty: 'Hakuna arifa bado. Tutakujulisha wakati kitu kitatokea.',
    employerMarkRead: 'Weka kama imesomwa',
    employerMarkAllRead: 'Weka zote zimesomwa',
    employerArchive: 'Hifadhi',
    employerNotifJobPosted: 'Kazi imechapishwa kwa mafanikio',
    notifWelcomeEmployerTitle: 'Karibu SmartJob Kenya',
    notifWelcomeEmployerMessage: 'Habari {name}, akaunti yako ya mwajiri iko tayari. Chapisha kazi yako ya kwanza kufikia vipaji vya karibu.',
    notifWelcomeSeekerTitle: 'Karibu SmartJob Kenya',
    notifWelcomeSeekerMessage: 'Habari {name}, akaunti yako ya mtafuta kazi iko tayari. Vinjari kazi za karibu na uanze kuomba leo.',
    seekerDashTitle: 'Dashibodi ya Mtafuta Kazi',
    seekerDashWelcome: 'Karibu tena',
    seekerDashSubtitle: 'Vinjari kazi, fuatilia maombi, na simamia wasifu wako.',
    seekerProfileSubtitle: 'Simamia picha yako na maelezo ya mawasiliano ili waajiri wakufikie.',
    seekerBrowseDesc: 'Tafuta kazi za kila siku, kwa saa, na malipo ya kila siku karibu nawe.',
    seekerTabBrowseJobs: 'Vinjari Kazi',
    seekerTabSavedJobs: 'Kazi Zilizohifadhiwa',
    seekerSavedJobsDesc: 'Kazi ulizohifadhi ili kuomba baadaye.',
    seekerNoSavedJobs: 'Hakuna kazi zilizohifadhiwa bado. Hifadhi kazi kutoka Vinjari Kazi ili kuomba baadaye.',
    seekerProfileCardDesc: 'Weka wasifu wako sawa kwa maombi ya haraka.',
    seekerApplications: 'Maombi',
    seekerApplicationsDesc: 'Fuatilia kazi ulizoomba na hali yao.',
    seekerTabApplications: 'Maombi Yangu',
    seekerNoApplications: 'Hakuna maombi bado. Vinjari kazi na omba ili uanze.',
    seekerApplyNow: 'Omba sasa',
    seekerApplying: 'Inawasilishwa...',
    seekerApplied: 'Umeomba',
    seekerApplyTitle: 'Omba kazi hii',
    seekerApplyDesc: 'Wasifu wako utashirikiwa na mwajiri pamoja na ujumbe wako.',
    seekerApplyMessage: 'Ujumbe wako kwa mwajiri',
    seekerApplyMessagePlaceholder: 'Jitambulishe, eleza uzoefu wako, na kwa nini unafaa...',
    seekerApplyMessageHint: 'Andika angalau maneno 15. Kuwa wazi na wa kitaalamu.',
    seekerApplyMessageTooShort: 'Ujumbe wako unahitaji angalau maneno 15 kabla ya kuwasilisha.',
    seekerApplyWordCount: '{count} / 15 maneno',
    seekerApplySubmit: 'Wasilisha ombi',
    seekerApplySuccessTitle: 'Ombi limewasilishwa',
    seekerApplySuccessMessage: 'Wasifu wako na ujumbe wako umetumwa kwa mwajiri. Unaweza kufuatilia hali chini ya Maombi Yangu.',
    seekerApplySuccessDone: 'Sawa',
    seekerWithdrawApplication: 'Ondoa ombi',
    seekerWithdrawTitle: 'Ondoa ombi?',
    seekerWithdrawConfirm: 'Una uhakika unataka kuondoa? Mwajiri hataona ombi lako kwa kazi hii tena.',
    seekerWithdrawConfirmBtn: 'Ndiyo, ondoa',
    seekerWithdrawCancel: 'Weka ombi',
    seekerWithdrawing: 'Inaondolewa...',
    seekerWithdrawSuccess: 'Ombi limeondolewa. Unaweza kuomba tena ukibadili mawazo.',
    seekerYourProfile: 'Wasifu wako',
    seekerApplicationMessage: 'Ujumbe wako',
    seekerAppliedOn: 'Uliomba',
    applicationStatusPending: 'Inasubiri',
    applicationStatusViewed: 'Imeangaliwa',
    applicationStatusContacted: 'Imewasiliana',
    employerViewApplicants: 'Angalia waombaji',
    employerApplicants: 'Waombaji',
    employerApplicantsDesc: 'Watu walioomba kazi hii.',
    employerNoApplicants: 'Hakuna maombi bado. Shiriki tangazo lako kuvutia wagombea.',
    employerApplicantProfile: 'Angalia wasifu',
    employerApplicantMessage: 'Ujumbe wa ombi',
    employerUpdateStatus: 'Sasisha hali',
    employerApplicantContact: 'Maelezo ya mawasiliano',
    employerApplicantApplied: 'Aliomba',
    employerApplicationCount: 'maombi',
    employerMarkContacted: 'Weka kama imewasiliana',
    employerMarkViewed: 'Weka kama imeangaliwa',
    employerSeekerProfile: 'Wasifu wa mwombaji',
    employerSeekerProfileDesc: 'Maelezo ya wasifu yaliyoshirikiwa na ombi lako.',
    employerSeekerPhone: 'Simu',
    employerSeekerEmail: 'Barua pepe',
    employerCloseApplicants: 'Funga',
    seekerNoJobs: 'Hakuna kazi zilizochapishwa bado. Rudi hivi karibuni.',
    seekerSearchNoResults: 'Hakuna kazi zinazolingana na utafutaji wako. Jaribu maneno au eneo tofauti.',
    seekerRefreshJobs: 'Onyesha upya',
    seekerJobsRefreshed: 'Orodha ya kazi imesasishwa. Inaonyesha kazi zote zinazopatikana.',
    seekerSearchFiltered: 'Inaonyesha matokeo yaliyochujwa.',
    seekerClearSearch: 'Onyesha kazi zote upya',
    seekerPostedBy: 'Imechapishwa na',
    seekerPostedOn: 'Imechapishwa',
    seekerLikeJob: 'Penda kazi hii',
    seekerDislikeJob: 'Usipende kazi hii',
    seekerJobDetails: 'Maelezo ya kazi',
    seekerBackToJobs: 'Rudi kwenye kazi',
    seekerSaveForLater: 'Hifadhi ili kuomba baadaye',
    seekerSavedForLater: 'Imehifadhiwa kwa baadaye',
    seekerJobNotFound: 'Kazi haipatikani au haipo tena.',
    seekerJobDescription: 'Maelezo',
    seekerEmployeesRequired: 'Wafanyakazi wanahitajika',
    seekerJobSaved: 'Kazi imehifadhiwa kwa baadaye',
    seekerJobUnsaved: 'Imeondolewa kwenye kazi zilizohifadhiwa',
    seekerRemoveFromSaved: 'Ondoa kwenye zilizohifadhiwa',
    shareJob: 'Shiriki kazi',
    shareJobCopied: 'Kiungo cha kazi kimenakiliwa! Mtumie rafiki.',
    shareJobShared: 'Kazi imeshirikiwa kwa mafanikio.',
    shareJobFailed: 'Imeshindwa kushiriki kazi hii. Jaribu tena.',
    landingNoJobs: 'Hakuna matangazo yanayoendelea bado. Kuwa mwajiri wa kwanza kuchapisha kazi.',
  },
};
